<div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto " >
    <div class="card2 card card0">
        <div class="card-header">
         <h4>Change Password</h4>
        </div>
        <div class="card-body">
            <form role="form" [formGroup]="formlogin" (submit)="submitlogin()">
                <div class="form-group">
                  <label for="exampleInputEmail1">Current Password</label>
                  <input type="password" class="form-control" formControlName="password" #password placeholder="Enter password">
                  <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
                </div>
                <div class="form-group">
                  <label for="exampleInputPassword1">New Password</label>
                  <input type="password" class="form-control" formControlName="new_password" #new_password placeholder="Enter Password">
                </div>
                <!-- <div class="form-group">
                    <label for="exampleInputPassword1">Captcha</label>
                    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (success)="handleSuccess($event)" [size]="size"
                    [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha" required>
                    </ngx-recaptcha2>  
                </div> -->
                
                <button type="submit" class="btn btn-primary">Submit</button>
              </form>
        </div>
      </div>
</div>